var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.727 0H2.273C1.017 0 0 1.017 0 2.273v20.454C0 23.983 1.017 25 2.273 25h20.454C23.983 25 25 23.983 25 22.727V2.273C25 1.017 23.983 0 22.727 0zM7.902 20.455H4.55V9.668h3.352v10.787zM6.192 8.126c-1.08 0-1.955-.876-1.955-1.954 0-1.079.875-1.954 1.955-1.954 1.077 0 1.953.876 1.953 1.954 0 1.078-.876 1.954-1.953 1.954zm14.267 12.329h-3.35v-5.246c0-1.251-.023-2.86-1.742-2.86-1.744 0-2.012 1.362-2.012 2.77v5.336h-3.35V9.668h3.215v1.474h.046c.448-.848 1.54-1.742 3.171-1.742 3.395 0 4.022 2.234 4.022 5.139v5.916z"}));
}

LinkedinIcon.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
